import React, { useCallback, useEffect, useRef } from 'react';
import { message } from 'antd';
import {
    SendGiftPageContainer,
    HeaderContainer,
    BodyContainer,
    StickerContainer,
    ButtonsContainer,
    TextContainer,
    GreenText,
    NormalText,
    EmailButton,
    WhatsappButton,
    CopyLinkButton,
    StyledDivider,
    DividerContainer,
    DividerText,
} from './style-components';
import gift from '@/assets/icons/gift/gift.svg';
import email from '@/assets/icons/email/email.svg';
import copy from '@/assets/icons/copy/copy.svg';
import SEOHelmet from '@/components/SEOHelmet/SEOHelmet';
import { getExchangeUrlLocalStorage } from '@/utils/local-storage/mission-exchange/mission-exchange';
import { amplitudeAddTrack, determineProjectName } from '@/utils/amplitud/event-track';

const SendGiftPage: React.FC = () => {

    const [messageApi, contextHolder] = message.useMessage();
    const giftLink = getExchangeUrlLocalStorage() ?? null;
    const handleEmailShare = useCallback(() => {
        if (!giftLink) {
            messageApi.error('No se pudo obtener el enlace del regalo');
            return;
        }
        localStorage.setItem('send-gift', 'true');
        const subject = "¡Te han enviado un regalo!";
        const url = giftLink + "?utm_source=Enviado&utm_medium=Correo&utm_id=RegaloEnviado"
        const body = `Hola, te han enviado un regalo. Puedes reclamarlo en el siguiente enlace: ${url}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }, [giftLink, messageApi]);

    const handleWhatsAppShare = useCallback(() => {
        if (!giftLink) {
            messageApi.error('No se pudo obtener el enlace del regalo');
            return;
        }
        localStorage.setItem('send-gift', 'true');
        const url = giftLink + "?utm_source=Enviado&utm_medium=Whatsapp&utm_id=RegaloEnviado"
        const text = `¡Hola! Te han enviado un regalo. Puedes reclamarlo en el siguiente enlace: ${url}`;
        window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
    }, [giftLink, messageApi]);

    const handleCopyLink = useCallback(async () => {
        try {
            if (!giftLink) {
                messageApi.error('No se pudo obtener el enlace del regalo');
                return;
            }
            localStorage.setItem('send-gift', 'true');
            const url = giftLink + "?utm_source=Enviado&utm_medium=Enlace&utm_id=RegaloEnviado"
            const text = `¡Hola! Te han enviado un regalo. Puedes reclamarlo en el siguiente enlace: ${url}`;
            await navigator.clipboard.writeText(text);
            messageApi.success('¡Enlace copiado al portapapeles!');
        } catch (error) {
            console.error(error);
            messageApi.error('Error al copiar el enlace');
        }
    }, [giftLink, messageApi]);

    const firstRenderAmplitude = useRef<boolean>(true);
    useEffect(() => {
        if (firstRenderAmplitude.current) {
            firstRenderAmplitude.current = false;
            amplitudeAddTrack(determineProjectName('Enviar regalo'), {
				title: determineProjectName('Enviar regalo'),
			})
        }
    }, []);

    return (
        <SendGiftPageContainer>
            <SEOHelmet
                metadata={{
                    title: determineProjectName('Enviar regalo'),
                    description: determineProjectName('Enviar regalo')
                }}
            />
            {contextHolder}
            <HeaderContainer>
                <GreenText>
                    ¡Obtenido exitosamente!
                </GreenText>
                <NormalText>
                    Ya puedes compartir este regalo con un amigo para que lo agregue a su wallet.
                </NormalText>
            </HeaderContainer>
            <BodyContainer>
                <StickerContainer>
                    <img src={gift} alt="gift" />
                </StickerContainer>
            </BodyContainer>
            <ButtonsContainer>
                <EmailButton onClick={handleEmailShare}>
                    Enviar por correo electrónico
                    <img src={email} alt="email" />
                </EmailButton>
                <WhatsappButton onClick={handleWhatsAppShare}>
                    Enviar por WhatsApp
                </WhatsappButton>
                <DividerContainer>
                    <StyledDivider />
                    <DividerText>
                        y
                    </DividerText>
                    <StyledDivider />
                </DividerContainer>
                <CopyLinkButton onClick={handleCopyLink}>
                    Copiar enlace
                    <img src={copy} alt="copy" />
                </CopyLinkButton>
            </ButtonsContainer>
            <TextContainer>
                <NormalText style={{ textAlign: 'left' }}>
                    Podrás ver este beneficio en tu wallet para enviarlo en cualquier momento.
                </NormalText>
            </TextContainer>
        </SendGiftPageContainer>
    );
};

export default SendGiftPage;
